import { useEffect, useState } from 'react';
import { localStorageService, StorageKeys } from '@ibk/shared-utils';
export const useInstructionsAmount = () => {
    const [amount, setAmount] = useState(0);
    useEffect(() => {
        async function fetchTotal() {
            const storedTotal = await localStorageService.getItem(StorageKeys.PendingPaymentsTotal);
            setAmount(typeof storedTotal === 'number' ? storedTotal : Number(storedTotal) || 0);
        }
        fetchTotal();
        const handleStorageChange = (event) => {
            if (event.key === StorageKeys.PendingPaymentsTotal) {
                fetchTotal();
            }
        };
        const handleCustomStorageChange = (event) => {
            if (event.detail?.key === StorageKeys.PendingPaymentsTotal) {
                fetchTotal();
            }
        };
        const handlePaymentChange = () => {
            setTimeout(fetchTotal, 100);
        };
        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('localStorageChange', handleCustomStorageChange);
        window.addEventListener('payment-approved', handlePaymentChange);
        window.addEventListener('payment-reproved', handlePaymentChange);
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('localStorageChange', handleCustomStorageChange);
            window.removeEventListener('payment-approved', handlePaymentChange);
            window.removeEventListener('payment-reproved', handlePaymentChange);
        };
    }, []);
    return amount;
};
